module.exports = require("react-transition-group");


//////////////////
// WEBPACK FOOTER
// external "react-transition-group"
// module id = 12
// module chunks = 0